import axios from 'axios'
import qs from 'qs'
import { snakeProps } from 'change-prop-case'

// error.statusでレスポンスステータスを取れるようにする
function setErrorStatus(error) {
  if (error.response) {
    error.status = error.statusCode = error.response.status
  }
  return Promise.reject(error)
}

function createInstance(getToken, config) {
  let axiosInstance = axios.create(
    Object.assign(
      {
        paramsSerializer: params =>
          qs.stringify(snakeProps(params), { indices: false }),
      },
      config
    )
  )
  // set token interceptors
  axiosInstance.interceptors.response.use(res => res.data, setErrorStatus)
  axiosInstance.interceptors.request.use(
    config => {
      // NOTE: axios.defaultsを使用すると別ユーザに影響がでるため
      // interceptorでtokenをセットする
      let token = null
      if (typeof getToken === 'function') {
        token = getToken()
      }
      if (!token) return config
      if (token) config.headers.common['Authorization'] = 'JWT ' + token
      return config
    },
    err => Promise.reject(err)
  )
  return axiosInstance
}

export default getToken => {
  const API_ENDPOINT =
    process.env.VUE_APP_API_ENDPOINT || 'http://localhost:30000/api/2/'
  let api = createInstance(getToken, {
    baseURL: API_ENDPOINT,
  })
  console.log('api endpoint', API_ENDPOINT)

  let http = {
    axios,
    http: api,
    auth: {
      obtainToken: data => api.post('auth/', data),
      refreshToken: data => api.post('auth/refresh/', data),
      verifyToken: data => api.post('auth/verify/', data),

      getAccount: token =>
        api.get('account/', { headers: { Authorization: `JWT ${token}` } }),
    },
    customers: id => ({
      get: params => api.get(`customers/${id}/`, { params }),
      update: data => api.patch(`customers/${id}/`, data),
      list: params => api.get('customers/', { params }),
      count: params => api.get('customers/count/', { params }),
      validate: data =>
        api.post(
          id ? `customers/${id}/validate/` : 'customers/validate/',
          data
        ),
      create: (data, opts) => api.post('customers/', data, opts),
      registration: data => api.post('customers/registration/', data),
    }),
    shops: id => ({
      get: params => api.get(`shops/${id}/`, { params }),
      list: params => api.get('shops/', { params }),
      menus: menuId => ({
        get: params => api.get(`shops/${id}/menus/${menuId}/`, { params }),
        list: params => api.get(`shops/${id}/menus/`, { params }),

        reservableTimes: date => ({
          get: params =>
            api.get(`shops/${id}/menus/${menuId}/reservable_times/${date}/`, {
              params,
            }),
        }),
      }),
      menuOptions: optionId => ({
        get: params =>
          api.get(`shops/${id}/menu_options/${optionId}/`, { params }),
        list: params => api.get(`shops/${id}/menu_options/`, { params }),
      }),
    }),
    counselingQuestions: id => ({
      get: params => api.get(`counseling_questions/${id}/`, { params }),
      list: params => api.get(`counseling_questions/`, { params }),
    }),
  }

  return http
}
